import { styled } from '@slal/ui';
import { Col } from '@slal/ui/layout';
import { Text } from '@slal/ui/typography';
import { Field } from '~/components';

export const StyledCol = styled(Col)`
    display: flex;
    align-items: center;
`;

export const StyledText = styled(Text)`
    color: ${({ theme }) => theme.colors.neutral__dark__30};
    margin-top: 16px;
    a {
        color: ${({ theme }) => theme.colors.aqua__70};
    }
`;

export const StyledField = styled(Field)`
    margin-top: ${({ theme }) => theme.space[5]};
    margin-bottom: 0;
`;
